// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"25":"1f4d248b","353":"241463ab","825":"80e30a59","839":"146e3869"}[chunkId] + ".chunk.css");